module.exports = __webpack_public_path__ + "static/media/Code-Assist.16e44c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/artwork/Code-Assist.png
// module id = 128
// module chunks = 0